import { createRouter, createWebHistory } from 'vue-router'

const adminRoutes = [
  {
    name: 'AdminList',
    path: 'admin/list',
    component: () => import('@/views/console/admin/AdminList.vue'),
  },
  {
    name: 'AdminAdd',
    path: 'admin/add',
    component: () => import('@/views/console/admin/AdminAdd.vue'),
  },
  {
    name: 'SystemList',
    path: 'system/list',
    component: () => import('@/views/console/system/SystemList.vue'),
  },
  {
    name: 'PermissionList',
    path: 'permission/list',
    component: () => import('@/views/console/permission/PermissionList.vue'),
  },
  {
    name: 'RoleList',
    path: 'role/list',
    component: () => import('@/views/console/role/RoleList.vue'),
  }
]

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    redirect: '/console/admin/list'
  },
  {
    path: '/console',
    name: 'AdminView',
    component: () => import('@/views/console/AdminView.vue'),
    children: adminRoutes,
    redirect: '/console/admin/list'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
